import { render, staticRenderFns } from "./ViewGatGridProperties.vue?vue&type=template&id=60958582&"
import script from "./ViewGatGridProperties.vue?vue&type=script&lang=js&"
export * from "./ViewGatGridProperties.vue?vue&type=script&lang=js&"
import style0 from "./ViewGatGridProperties.vue?vue&type=style&index=0&id=60958582&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports